import * as tf from '@tensorflow/tfjs';
import LeelaZeroEncoder from './leelaZeroEncoder';
import Engine from './engine';

class LeelaZeroEngine extends Engine {

  constructor() {
    super();
    this.name = "LeelaZero";
    const baseUrl = "https://storage.googleapis.com/fujigoban2-models";
    this.url = `${baseUrl}/${this.modelName}/model.json`;
    this.encoder = new LeelaZeroEncoder();
  }

  get models() {
    return [
      // 116 2018-04-04 09:37	39d46507	10x128	9888
      "leelazero_10x128.js",
      // 157 2018-07-18 14:36	d351f06e	15x192	11806
      "leelazero_15x192.js"
      // 173 2018-09-03 13:14	33986b7f	20x256	12278	
      // "leelazero_20x256.js"
    ];
  }

  async predict(key, history) {
    const cache = await this.predictionStore.get(key);
    if (cache) {
      const policyOutputPromise = new Promise(resolve => {
        resolve(cache.priorProbability);
      });
      const valueOutputPromise = new Promise(resolve => {
        resolve(cache.valueOutput);
      });
      return Promise.all([policyOutputPromise, valueOutputPromise]);
    }
    const output = tf.tidy(() => {
      const input = this.encoder.encode(history.slice());
      const pred = this.model.predict(input.expandDims(0));
      const policy = pred[0].squeeze().softmax().array();
      const value = pred[1].squeeze().clipByValue(-0.998, 0.998).array();
      return [policy, value];
    });
    return Promise.all(output);
  }
}

export default LeelaZeroEngine;